// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2s9Xu","insightsList":"newBusinessInsightsMenu_insightsList__jrgiE","active":"newBusinessInsightsMenu_active__310gE"};